(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-sidebar"] && !Shopify.designMode) return;
  try {
    // 1. Handle <a> click separately — navigate only, no dropdown
document.querySelectorAll('.header-sidebar__linklist-button a').forEach(link => {
  link.addEventListener('click', (e) => {
    e.stopPropagation(); // Prevent bubble to <summary>
    e.preventDefault();  // Block default <a> behavior
    window.location.href = link.getAttribute('href'); // Navigate manually
  });
});

// 2. Handle <summary> click — only toggle dropdown on SVG chevron click
document.querySelectorAll('.header-sidebar__linklist-button').forEach(summary => {
  summary.addEventListener('click', (e) => {
    e.preventDefault(); // Block <details> default toggle completely

    // Only toggle dropdown if SVG chevron is clicked
    if (e.target.closest('.accordion-chevron')) {
      const details = summary.closest('details');
      details.hasAttribute('open')
        ? details.removeAttribute('open')
        : details.setAttribute('open', '');
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
